<template>
  <div class="food-manage">
    <div class="course-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="适用年级" class="fn-left">
            <Select key="10" :selected.sync="listQuery.gradeId" :data="gradeLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="适用科目" class="fn-left">
            <Select key="5" :selected.sync="listQuery.subjectId" :data="subjectLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetClassContentList">查询</el-button>
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="success" @click="fnAddClassContent()">添加</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="ID" prop="id" align="center" />
        <el-table-column label="课程名称" prop="title" align="center" />
        <el-table-column label="适用年级" prop="grade_names" align="center" />
        <el-table-column label="适用科目" prop="subject_name" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <div>
              <el-button type="text" @click="fnToClassContentSetting(row.id)">编辑</el-button>
              <el-button type="text" :loading="currentLoading == row.id" @click="fnDelete(row.id)">删除</el-button>
              <el-button type="text" :loading="currentLoading == row.id" @click="fnGetQuick(row.id)">快捷回复</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="total" :page-size="20" @current-change="fnGetClassContentList" />
    </div>
    <el-dialog title="创建&编辑" :visible.sync="dialogFormVisible">
      <el-form ref="postForm" :model="postForm" :rules="rules" label-position="labelPosition" class="filter-input">
        <el-form-item label="课程名称" label-width="120px" prop="title">
          <el-input v-model="postForm.title" placeholder="请输入课程名称" />
        </el-form-item>
        <el-form-item label="课程科目" label-width="120px" prop="subjectId">
          <Select key="15" :selected.sync="postForm.subjectId" :data="subjectLists" clearable placeholder="请选择课程科目" />
        </el-form-item>
        <el-form-item label="适用年级" label-width="120px" prop="gradeId">
          <el-checkbox-group v-model="postForm.gradeId">
            <el-checkbox v-for="(item,index) in gradeLists" :key="'grade' + index" :label="item.id">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="课程介绍" label-width="120px">
          <el-input v-model="postForm.content" type="textarea" placeholder="请输入课程介绍" />
        </el-form-item>
        <el-button type="primary" :loading="bCreateLoading" @click="fnUpdateCoefficientSubmit()">确定</el-button>
      </el-form>
    </el-dialog>
    <el-dialog title="快捷回复" :visible.sync="dialogShowQuickVisable" width="90%">
      <el-button type="primary" style="margin-bottom: 10px;" @click="addQuick()">添加</el-button>
      <el-table :key="`quick${quickTableKey}`" :data="quickLists" border stripe>
        <el-table-column label="日期" prop="back_date" align="center" />
        <el-table-column label="课程名" prop="class_title" align="center" />
        <el-table-column label="快捷回复内容" prop="content" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button type="text" @click="fnUpdateQuick(row)">编辑</el-button>
            <el-button type="text" :loading="currentLoading == row.id" @click="fnDeleteQuick(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

    </el-dialog>
    <el-dialog title="快捷回复" :visible.sync="dialogUpdateQuickVisable" width="90%">
      <el-form ref="postForm" :model="postForm" :rules="rules" label-position="labelPosition" class="filter-input">
        <el-form-item v-if="!currentQuick.id" label="时间范围" label-width="90px" prop="title">
          <el-date-picker
            v-model="quickTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item v-if="currentQuick.id && currentQuick.back_date" label="时间" label-width="90px" prop="title">
          <span>{{ currentQuick.back_date }}</span>
        </el-form-item>
        <el-form-item label="快捷回复" label-width="90px">
          <el-input v-model="currentQuick.content" type="textarea" placeholder="请输入快捷回复" />
        </el-form-item>
        <el-button type="primary" :loading="bCreateLoading" @click="fnSubmitQuick()">确定</el-button>
      </el-form>

    </el-dialog>
  </div>

</template>
<script>

import Select from '@/components/Select'
import commondata from '@/utils/commondata'
import { validateRequire } from '@/utils/validate'

const defaultPostForm = {
  title: '',
  content: '',
  subjectId: '',
  gradeId: [],
  id: ''
}

export default {
  name: 'TyyKnowledgeSettingLists',
  components: {
    Select
  },
  data() {
    return {
      dialogShowQuickVisable: false,
      dialogUpdateQuickVisable: false,
      quickTableKey: 0,
      quickTimeRange: [],
      currentQuick: {
        content: '',
        class_id: '',
        back_date: ''
      },
      quickLists: [],
      rules: {
        title: [{ validator: validateRequire, trigger: 'manual', message: '课程名称' }],
        subjectId: [{ validator: validateRequire, trigger: 'manual', message: '课程科目' }],
        gradeId: [{ validator: (rule, value, callback) => {
          if (value.length === 0) {
            this.$message({ message: rule.message + '为必传项', type: 'error' })
          } else {
            callback()
          }
        }, trigger: 'manual', message: '适用年级' }]
      },
      lists: [],
      tableKey: 0,
      listQuery: {
        p: 1,
        subjectId: '',
        gradeId: ''
      },
      gradeLists: commondata.GRADE_LISTS,
      subjectLists: commondata.SUBJECT_MAP,
      currentLoading: '',
      total: 0,
      postForm: Object.assign({}, defaultPostForm),
      dialogFormVisible: false,
      bCreateLoading: false
    }
  },
  created() {
    this.fnGetClassContentList()
  },
  methods: {
    fnUpdateCoefficientSubmit: function() {
      this.$refs.postForm.validate(valid => {
        if (valid) {
          const form = Object.assign({}, this.postForm)
          form.gradeId = form.gradeId.join(',')
          this.bCreateLoading = true
          this.$http.improveClassContent(form).then(res => {
            this.$message({
              message: '操作成功！',
              type: 'success'
            })
            this.bCreateLoading = false
            this.dialogFormVisible = false
            this.fnGetClassContentList()
          })
        }
      })
    },
    fnAddClassContent: function() {
      this.postForm = Object.assign({}, defaultPostForm)
      this.dialogFormVisible = true
    },
    fnGetClassContentList: function() {
      this.$http.getClassContentList(this.listQuery).then(res => {
        this.total = parseInt(res.data.count)
        this.lists = res.data.list
      })
    },
    fnToClassContentSetting(id) {
      this.$http.getClassContentInfo({ id }).then(res => {
        const { data } = res
        this.postForm = {
          title: data.title,
          content: data.content,
          subjectId: parseInt(data.subject_id),
          gradeId: data.grade_ids.split(','),
          id: data.id
        }
        this.dialogFormVisible = true
      })
    },
    fnGetQuick(class_id) {
      this.$http.getQuickReplyList({ class_id }).then((res) => {
        this.quickTableKey++
        this.currentQuick.class_id = class_id
        this.quickLists = res.data
        this.dialogShowQuickVisable = true
      })
    },
    fnUpdateQuick(quick) {
      this.currentQuick.id = quick.id
      this.currentQuick.back_date = quick.back_date
      this.currentQuick.content = quick.content
      this.dialogUpdateQuickVisable = true
    },
    fnDeleteQuick(id) {
      this.$confirm('确认删除此条评价么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        this.$http.removeQuickReply({ id }).then(() => {
          this.dialogUpdateQuickVisable = false
          this.fnGetQuick(this.currentQuick.class_id)
        })
      })
    },
    fnSubmitQuick() {
      if (this.currentQuick.id) {
        this.$http.changeQuickReply({ id: this.currentQuick.id, content: this.currentQuick.content }).then(() => {
          this.dialogUpdateQuickVisable = false
          this.fnGetQuick(this.currentQuick.class_id)
        })
        // 编辑
      } else {
        // 添加
        this.$http.setQuickReply(
          { class_id: this.currentQuick.class_id, begin_day: this.quickTimeRange[0], end_day: this.quickTimeRange[1], content: this.currentQuick.content }
        ).then(() => {
          this.dialogUpdateQuickVisable = false
          this.fnGetQuick(this.currentQuick.class_id)
        })
      }
    },
    addQuick(class_id) {
      this.currentQuick.id = ''
      this.currentQuick.content = ''
      this.dialogUpdateQuickVisable = true
    },
    fnDelete(id) {
      this.$confirm('确认删除课程内容么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        this.currentLoading = id
        this.$http.removeClassContent({ id }).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
            this.currentLoading = ''
            this.fnGetClassContentList()
          }
        })
      })
    }
  }
}
</script>
<style lang="scss">
  .course-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
